<template>
	<div id="default">
	</div>
</template>

<script>

export default {
  name: 'DefaultPage',
  components: {
  },
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
